export const COUPON_TNC_FALLBACK_TXT = `Sorry :(, We don't have T&C for this coupon`;

export const COUPON_FIELD_MAPPING = {
	COUPON_ID: 'cid',
	COUPON_CODE: 'code'
};

export const GAME_NAMES = {
	LUDO: 'LUDO',
	NINJA: 'NINJA',
	TURBO: 'TURBO',
	SNLT: 'SNLT',
	CARROM: 'CARROM',
	LUDONX: 'LUDONX',
	TC: 'TC',
	CT: 'CT',
	TCNX: 'TCNX',
	ZKJ: 'ZKJ',
	HC: 'HC',
	ZUPEE11: 'ZUPEE11'
};

export const GAME_NAME_OPTIONS = {
	[GAME_NAMES.LUDO]: 'ludo',
	[GAME_NAMES.NINJA]: 'ninja',
	[GAME_NAMES.TURBO]: 'turbo',
	[GAME_NAMES.SNLT]: 'snlt',
	[GAME_NAMES.CARROM]: 'carrom',
	[GAME_NAMES.LUDONX]: 'ludonx',
	[GAME_NAMES.TC]: 'tc',
	[GAME_NAMES.CT]: 'ct',
	[GAME_NAMES.TCNX]: 'tcnx',
	[GAME_NAMES.ZKJ]: 'zkj',
	[GAME_NAMES.HC]: 'hc',
	[GAME_NAMES.ZUPEE11]: 'zupee11'
};

export const GAME_NAME_LABLES = {
	[GAME_NAMES.LUDO]: 'Ludo Supreme',
	[GAME_NAMES.NINJA]: 'Ludo Ninja',
	[GAME_NAMES.TURBO]: 'Ludo Turbo',
	[GAME_NAMES.SNLT]: 'Snake and Ladders Plus',
	[GAME_NAMES.CARROM]: 'Carrom Ninja',
	[GAME_NAMES.LUDONX]: 'Ludo Supreme League',
	[GAME_NAMES.TC]: 'Cricket Trump Cards',
	[GAME_NAMES.CT]: 'Cricket Tambola',
	[GAME_NAMES.TCNX]: 'Zupee Cricket Cards',
	[GAME_NAMES.ZKJ]: 'Zupee Cricketbaaz',
	[GAME_NAMES.HC]: 'Zupee Super Over',
	[GAME_NAMES.ZUPEE11]: 'Zupee 11'
};

export const ACL_CRM_RESOURCES: string[] = ['referrals', 'previousTickets', 'coupons', 'lotteryWinnings'];

export const BULK_QUERY_LABELS: Record<string, string> = {
	GET_SUSPICIOUS_TRANSACTIONS: 'GET_SUSPICIOUS_TRANSACTIONS'
};
